<template>
  <div class="get-more" id="getMore">
    <div class="msg-main">
      <div class="msg-title">
        <h1>获得更多推广相关咨询</h1>
        <a><img src="../assets/images/right-arrow.png"></a>
      </div>
      <div class="msg-content">
        <div class="msg-content-left">
          <div>
            联系人姓名
            <el-input type="text" v-model="name"></el-input>
          </div>
          <div>
            公司名称
            <el-input type="text" v-model="cname"></el-input>
          </div>
          <div>
            联系人手机
            <el-input type="phone" v-model="phone"></el-input>
          </div>
          <div>
            公司所在地
            <el-input type="text" class="location-1" v-model="location"></el-input>
          </div>
          <input type="button" value="提交" class="submit-btn" @click="submit">
        </div>
        <div class="msg-content-right">
          <h1>让咨询顾问为你免费服务</h1>
          <h1><i></i>177-2473-1490</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'GetMore',
  data: function () {
    return {
      name: '',
      cname: '',
      phone: '',
      location: ''
    }
  },
  methods: {
    submit: function () {
      var that = this

      axios({
        method: 'post',
        url: 'http://test.paotuanbang.cn/Service/PCMerchants/add_pc_users',
        data: qs.stringify({
          'username': that.name,
          'mobile': that.phone,
          'company': that.cname,
          'address': that.location,
          'score': 1
        })
      }).then(function (response) {
        that.name = ''
        that.phone = ''
        that.cname = ''
        that.location = ''
        alert('提交成功，跑团邦咨询顾问将在稍后联系您。')
      })
    }
  }
}
</script>

<style scoped lang="stylus">
  .get-more
    width: 100%
    background-color: #eeeeee
    background-image: url("../assets/images/third-background.png")
    background-position: center
    background-size: cover
    .msg-main
      width: 84%
      max-width: 1200px;
      margin: 0 auto
      padding-bottom: 70px
      .msg-title
        margin-left: 71px;
        h1
          padding-top: 55px
          font-weight: 400
          font-size: 32px
          display: inline-block
          margin: 0
        a
          display: inline-block
          vertical-align: bottom
          img
            width: 37px
            margin-left: 30px
            vertical-align: bottom
      .msg-content
        margin: 60px 0 0 71px;
        display: flex
        vertical-align: top
        width: 100%
        .msg-content-left
          max-width: 770px
          display: inline-block
          div
            display: inline-block
            line-height: 40px
            &:nth-child(2)
              margin-left: 43px
            &:nth-child(4)
              margin-left: 28px
            &:nth-child(n+3)
              margin-top: 48px
            label
              vertical-align: top
            .el-input
              width: 214px
              height: 40px
              margin-left: 20px
              display: inline-block
            .location-1
              width: 110px;
          .submit-btn
            width: 208px
            height: 48px
            display: inline-block
            border-radius: 25px
            border: none
            background-color: #e32232
            color: white
            margin-top: 70px
        .msg-content-right
          vertical-align: top
          width: 370px
          display: inline-block
          i
            width: 43px
            height: 43px
            display: inline-block
            background-image: url("../assets/images/phone-icon.png")
            background-position: center
            background-size: cover
            vertical-align: middle
            margin-right: 20px
          h1:nth-child(1)
            font-size: 23px
            font-weight: 400
            margin-left: 80px
          h1:nth-child(2)
            font-size: 42px
            font-weight: 400
            line-height: 43px
            color: #ec2f46
</style>



// WEBPACK FOOTER //
// src/components/GetMore.vue